import Icon from '../Icon/Icon';
import styles from './EmptyState.module.css';

// Placeholder for empty lists / not-yet-built areas.
// `icon` accepts a Lucide icon name (preferred) or a node (back-compat).
export default function EmptyState({ icon = 'Sparkles', title, description, action }) {
  const renderIcon = () => {
    if (typeof icon === 'string') return <Icon name={icon} size={28} tone="accent" />;
    return icon;
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.frame}>
        {`┌─────────────────────┐\n│   NO DATA FOUND     │\n└─────────────────────┘`}
      </div>
      <div className={styles.icon}>{renderIcon()}</div>
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
